export const BACKGROUND_GROUP_ID = 'BACKGROUND_GROUP';
export const TRANSITION_GROUP_ID = 'TRANSITION_GROUP';
